import {get} from "lodash"
import BaseService from "./Base"
import {ArchivedUserListItem} from "types/archived-users"

class ArchivedUsersService extends BaseService {
    async list(params): Promise<{total: number; data: ArchivedUserListItem[]}> {
        const response = await this.post("/v1/archived-users/list", params)
        return get(response, "data", {data: [], total: 0})
    }

    async restore(profileId: number): Promise<void> {
        await this.post("/v1/archived-users/restore", {profileId})
    }
}

export default ArchivedUsersService
